/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import { PortalLink, type LearningCourseDetail } from '@akademi/site-builder-runtime';
import { Card } from '@akademi/ui';

interface ResourceListProps {
  resources: NonNullable<LearningCourseDetail['resources']>;
}

export function ResourceList({ resources }: ResourceListProps) {
  if (resources.length === 0) return null;
  return (
    <ul className="cd-resources">
      {resources.map((r, i) => (
        <li key={i}>
          <Card asChild>
            <PortalLink
              className="cd-resource"
              href={r.href ?? '#'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="cd-resource-icon">{labelForType(r.type)}</span>
              <span className="cd-resource-meta">
                <span className="cd-resource-title">{r.title}</span>
                {r.size && <span className="cd-resource-size">{r.size}</span>}
              </span>
              <span className="cd-resource-arrow" aria-hidden>
                →
              </span>
            </PortalLink>
          </Card>
        </li>
      ))}
    </ul>
  );
}

function labelForType(type: 'pdf' | 'link' | 'code' | 'archive'): string {
  switch (type) {
    case 'pdf':
      return 'PDF';
    case 'code':
      return '{ }';
    case 'archive':
      return 'ZIP';
    case 'link':
      return '↗';
  }
}
